import adfolksLogo from "@/assets/adfolks-logo.png";
import appsintegraLogo from "@/assets/appsintegra-logo.png";
import onepaneLogo from "@/assets/onepane-logo.png";
import nimoLogo from "@/assets/nimo-logo.png";
import actualizeLogo from "@/assets/actualize-logo.svg";
import raigenLogo from "@/assets/raigen-logo.png";
import siroccoLogo from "@/assets/sirocco-logo.svg";
import rushotLogoAsset from "@/assets/rushot-logo.png.asset.json";

export interface PortfolioCompany {
  id: string;
  name: string;
  tagline: string;
  description: string;
  fullDescription?: string;
  industry?: string;
  category?: string;
  stage: string;
  founded?: string;
  website: string;
  logo: string;
  coverImage?: string;
  metrics?: {
    growth?: string;
    partnership?: string;
    impact?: string;
  };
  highlights?: string[];
  documents?: {
    title: string;
    type: 'pitch-deck' | 'case-study' | 'whitepaper' | 'report';
    embedUrl: string;
  }[];
}

export const portfolioCompanies: PortfolioCompany[] = [
  {
    id: "sirocco",
    name: "Sirocco Ventures",
    tagline: "Making the Good, Great",
    description: "Consulting and R&D firm specializing in practical generative AI solutions: tailor-made consulting, PoC and MVP development, and GenAI stack observability that turn AI into sustainable growth. Arun is Investor & Operating Partner.",
    logo: siroccoLogo,
    stage: "Active",
    category: "Consulting & AI",
    website: "https://www.siroccoventures.com/",
    metrics: {
      growth: "Strategic Planning Focus",
      partnership: "AI Solution Development",
      impact: "Business Excellence"
    },
    highlights: [
      "Tailor-made consulting and R&D services",
      "PoC/MVP development and deployment",
      "GenAI stack observability and optimization",
      "Cost tracking and ROI analysis"
    ]
  },
  {
    id: "adfolks",
    name: "Adfolks LLC",
    tagline: "Microsoft Ecosystem Modernization Specialist",
    description: "A Microsoft ecosystem-focused startup specializing in application modernization and cloud-native engineering. Under Arun's leadership, Adfolks grew into a high-performance modernization company and was later acquired by ZainTech, part of the Zain Telecom Group.",
    logo: adfolksLogo,
    stage: "Acquired",
    category: "Cloud Modernization",
    website: "https://www.adfolks.com",
    metrics: {
      growth: "Acquired by ZainTech",
      partnership: "Microsoft GTM Alignment",
      impact: "Deep Co-selling Motions"
    },
    highlights: [
      "Built on Microsoft ecosystem alignment",
      "Productized services through partner channels",
      "Successfully acquired by ZainTech (Zain Telecom Group)",
      "Proved ecosystem-first growth model"
    ]
  },
  {
    id: "appsintegra",
    name: "AppsIntegra",
    tagline: "AWS Ecosystem Modernization & Automation",
    description: "A modernization and automation specialist leveraging the AWS ecosystem to deliver DevOps, containerization, and platform engineering for enterprises. AppsIntegra grew regionally by focusing on ecosystem GTM and partner packaging.",
    logo: appsintegraLogo,
    stage: "Acquired",
    category: "DevOps & Automation",
    website: "https://www.linkedin.com/company/appsintegra/",
    metrics: {
      growth: "Regional Expansion",
      partnership: "AWS Ecosystem Focus",
      impact: "Partner Packaging Model"
    },
    highlights: [
      "AWS-native DevOps and containerization",
      "Ecosystem GTM and partner bundling",
      "Platform engineering for enterprises",
      "Sustainable growth through channel distribution"
    ]
  },
  {
    id: "nimo-infinity",
    name: "Nimo Infinity",
    tagline: "World's First AI-Secure Spatial Browser",
    description: "Creators of Nimo — the world's first AI-secure spatial browser. As investor and ecosystem GTM lead, Arun helped position the product through hyperscaler partnerships and regional distribution networks, proving how next-gen products can scale faster through trusted ecosystems.",
    logo: nimoLogo,
    stage: "Seed",
    category: "AI & Security",
    website: "https://www.nimoinfinity.com",
    metrics: {
      growth: "Hyperscaler Distribution",
      partnership: "Regional Networks",
      impact: "Next-gen Product Positioning"
    },
    highlights: [
      "First AI-secure spatial browser globally",
      "Hyperscaler partnership strategy",
      "Regional distribution network access",
      "Ecosystem-driven product launch"
    ]
  },
  {
    id: "onepane",
    name: "Onepane.ai",
    tagline: "Sovereign AI Agent Control Planes",
    description: "Sovereign AI agent control planes that give enterprise IT governance, safety, and cost control over AI agent fleets. Arun works with Onepane as Investor & Operating Partner on enterprise GTM and Microsoft and AWS co-sell.",
    logo: onepaneLogo,
    stage: "Seed",
    category: "AI Infrastructure",
    website: "https://www.onepane.ai",
    metrics: {
      growth: "Dual Hyperscaler Strategy",
      partnership: "Microsoft & AWS GTM",
      impact: "Enterprise Transformation"
    },
    highlights: [
      "AI-driven cloud resiliency platform",
      "Dual Microsoft and AWS alignment",
      "Ecosystem-ready solution architecture",
      "Enterprise co-sell positioning"
    ],
    documents: [
      {
        title: "Onepane Microsoft Partner deck",
        type: "pitch-deck",
        embedUrl: "https://www.slideshare.net/slideshow/embed_code/key/J6faOJNjQj6V4X?hostedIn=slideshare&page=upload"
      }
    ]
  },
  {
    id: "actualize",
    name: "Actualize.pro",
    tagline: "Arabic Voice AI for the GCC",
    description: "Voice agents that speak Arabic the way people in the GCC actually speak it. Founded and scaled by Arun, and acquired by CNTXT Tech.",
    logo: actualizeLogo,
    stage: "Acquired",
    category: "Voice AI",
    website: "https://www.actualize.pro/",
    metrics: {
      growth: "Enterprise Focus",
      partnership: "Hyperscaler Alignment",
      impact: "AI-Driven Transformation"
    },
    highlights: [
      "Enterprise AI platform",
      "Ecosystem-led go-to-market",
      "Strategic hyperscaler partnerships",
      "Accelerated market positioning"
    ]
  },
  {
    id: "benev",
    name: "Benev",
    tagline: "Physical AI for Everyday Glasses",
    description: "A device that makes every pair of glasses smart. Benev brings AI into the physical world through hardware people already wear every day. Arun is Investor & Operating Partner.",
    logo: "B",
    stage: "Seed",
    category: "Physical AI",
    website: "",
    highlights: [
      "Physical AI hardware for everyday eyewear",
      "Investor and Operating Partner support",
      "Consumer hardware distribution strategy"
    ]
  },
  {
    id: "rushot",
    name: "Rushot",
    tagline: "Professional Content Creators on Demand",
    description: "Book through the app and a creator arrives at your location to shoot, edit, and hand over polished short-form videos, often before your event wraps up. Arun is Investor & Operating Partner.",
    logo: rushotLogoAsset.url,
    stage: "Seed",
    category: "Creator Economy",
    website: "",
    highlights: [
      "On-demand professional content creators",
      "Same-event editing and delivery",
      "Investor and Operating Partner support"
    ]
  },
  {
    id: "raigen",
    name: "RAIGen AI",
    tagline: "Guardian Engine for Responsible AI",
    description: "Enterprise platform for Responsible AI governance and compliance. RAIGen centralizes AI governance policies, ensures regulatory compliance, and drives sustainable AI innovation across organizations. Arun guides their ecosystem GTM strategy to position RAIGen as a trusted partner for enterprises navigating AI governance.",
    logo: raigenLogo,
    stage: "Seed",
    category: "AI Governance",
    website: "https://raigen.ai/",
    metrics: {
      growth: "Enterprise Governance Focus",
      partnership: "Compliance & Risk Alignment",
      impact: "Regulatory Compliance"
    },
    highlights: [
      "Unified Responsible AI governance platform",
      "Multi-stakeholder collaboration framework",
      "Global regulatory alignment and compliance",
      "Enterprise-ready AI risk management"
    ]
  }
];
